module.exports = __webpack_public_path__ + "static/kakunin-f0d7cad75679b9fc9e3614b5418add00.png";